import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import backgroundImg from '../../assets/screens/screen-confirmation-multiple.png';
import CardReaderScreen from '../../molecules/CardReaderScreen/CardReaderScreen';
import {
  TICKET_TYPE_EXTRA_TICKET,
  TICKET_TYPE_VALUE_TICKET,
} from '../../constants';
import ConfirmationScreenContent from '../../molecules/ConfirmationScreenContent/ConfirmationScreenContent';
import {
  getTicketExpirationStringForZones,
  getDateString15DaysFromNow,
} from '../../time';
import { getTicketPrice } from '../../price';

class ExtraTicketConfirmationRC extends PureComponent {
  render() {
    const {
      currentZone,
      zones,
      seasonalTicketZones,
      passengers,
      remainingFunds,
    } = this.props;

    const seasonalTicket = {
      zones: seasonalTicketZones,
      validityEndsAtString: getDateString15DaysFromNow(),
    };

    const valueTicket = {
      zones,
      passengers,
      price: getTicketPrice(TICKET_TYPE_VALUE_TICKET, zones),
      validityEndsAtString: getTicketExpirationStringForZones(zones),
    };
    return (
      <CardReaderScreen backgroundImage={backgroundImg}>
        <ConfirmationScreenContent
          currentZone={currentZone}
          ticketType={TICKET_TYPE_EXTRA_TICKET}
          seasonalTicket={seasonalTicket}
          valueTicket={valueTicket}
          remainingFunds={remainingFunds}
        />
      </CardReaderScreen>
    );
  }
}

ExtraTicketConfirmationRC.propTypes = {
  currentZone: PropTypes.string.isRequired,
  zones: PropTypes.string.isRequired,
  seasonalTicketZones: PropTypes.string.isRequired,
  passengers: PropTypes.number.isRequired,
  remainingFunds: PropTypes.number.isRequired,
};

const mapStateToProps = ({ cardReader }) => ({
  currentZone: cardReader.currentZone,
  zones: cardReader.extraTicket.zones,
  seasonalTicketZones: cardReader.extraTicket.seasonalTicketZones,
  passengers: cardReader.extraTicket.passengers,
  remainingFunds: cardReader.remainingFunds,
});

export default connect(mapStateToProps)(ExtraTicketConfirmationRC);
